import React, { Component, PropTypes } from 'react'
import { Modal, Button } from 'react-bootstrap'
import autobind from 'autobind-decorator'

@autobind
export default class ExtendSessionModal extends Component {
  render() {
    let { show, onClose, extendSession } = this.props
    return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Extend Session</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to extend session?</Modal.Body>
        <Modal.Footer>
          <Button onClick={onClose}>Close</Button>
          <Button bsStyle='success' onClick={extendSession}>
            Extend
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/ExtendSessionModal.js